import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Unit
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import com.solevo.dist.pages.Index as _com_solevo_dist_pages_Index
import com.solevo.dist.pages.Login as _com_solevo_dist_pages_Login
import com.solevo.dist.pages.OrdersScreen as _com_solevo_dist_pages_OrdersScreen
import com.solevo.dist.pages.RewardsScreen as _com_solevo_dist_pages_RewardsScreen
import com.solevo.dist.pages.SettingsScreen as _com_solevo_dist_pages_SettingsScreen
import com.solevo.dist.pages.TermsAndPrivacyScreen as _com_solevo_dist_pages_TermsAndPrivacyScreen
import com.solevo.dist.pages.orderdetails.DeliveryNoteScreen as _com_solevo_dist_pages_orderdetails_DeliveryNoteScreen
import com.solevo.dist.pages.orderdetails.InvoiceDetailsScreen as _com_solevo_dist_pages_orderdetails_InvoiceDetailsScreen
import com.solevo.dist.pages.orderdetails.OrderDetailsScreen as _com_solevo_dist_pages_orderdetails_OrderDetailsScreen
import com.solevo.dist.pages.productdetails.ProductDetailsScreen as _com_solevo_dist_pages_productdetails_ProductDetailsScreen
import com.solevo.dist.pages.quotes.QuoteDetailsScreen as _com_solevo_dist_pages_quotes_QuoteDetailsScreen
import com.solevo.dist.pages.quotes.QuotesScreen as _com_solevo_dist_pages_quotes_QuotesScreen
import com.solevo.dist.pages.statements.StatementScreen as _com_solevo_dist_pages_statements_StatementScreen
import com.solevo.dist.pages.statements.TransactionDetailsScreen as _com_solevo_dist_pages_statements_TransactionDetailsScreen

public fun main(): Unit {
    AppGlobals.initialize(mapOf("title" to "SolevoWebApp"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _com_solevo_dist_pages_Index()
        }
        ctx.router.register(
            "/login",
        ) { pageCtx -> 
            _com_solevo_dist_pages_Login()
        }
        ctx.router.register(
            "/orderdetails/deliverynote",
        ) { pageCtx -> 
            _com_solevo_dist_pages_orderdetails_DeliveryNoteScreen()
        }
        ctx.router.register(
            "/orderdetails/invoice",
        ) { pageCtx -> 
            _com_solevo_dist_pages_orderdetails_InvoiceDetailsScreen()
        }
        ctx.router.register(
            "/orderdetails/order",
        ) { pageCtx -> 
            _com_solevo_dist_pages_orderdetails_OrderDetailsScreen()
        }
        ctx.router.register(
            "/orders",
        ) { pageCtx -> 
            _com_solevo_dist_pages_OrdersScreen()
        }
        ctx.router.register(
            "/productdetails/product",
        ) { pageCtx -> 
            _com_solevo_dist_pages_productdetails_ProductDetailsScreen()
        }
        ctx.router.register(
            "/quotes",
        ) { pageCtx -> 
            _com_solevo_dist_pages_quotes_QuotesScreen()
        }
        ctx.router.register(
            "/quotes/details",
        ) { pageCtx -> 
            _com_solevo_dist_pages_quotes_QuoteDetailsScreen()
        }
        ctx.router.register(
            "/rewards",
        ) { pageCtx -> 
            _com_solevo_dist_pages_RewardsScreen()
        }
        ctx.router.register(
            "/settings",
        ) { pageCtx -> 
            _com_solevo_dist_pages_SettingsScreen()
        }
        ctx.router.register(
            "/statement",
        ) { pageCtx -> 
            _com_solevo_dist_pages_statements_StatementScreen()
        }
        ctx.router.register(
            "/statement/transaction",
        ) { pageCtx -> 
            _com_solevo_dist_pages_statements_TransactionDetailsScreen()
        }
        ctx.router.register(
            "/terms-and-privacy",
        ) { pageCtx -> 
            _com_solevo_dist_pages_TermsAndPrivacyScreen()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("labels_label", com.solevo.dist.styles.UiStyles.Labels.label)
        ctx.theme.registerStyle("buttons_primary-button",
                com.solevo.dist.styles.UiStyles.Buttons.primaryButton)
        ctx.theme.registerStyle("buttons_primary-button-full-width",
                com.solevo.dist.styles.UiStyles.Buttons.primaryButtonFullWidth)
        ctx.theme.registerStyle("buttons_primary-button-compact",
                com.solevo.dist.styles.UiStyles.Buttons.primaryButtonCompact)
        ctx.theme.registerStyle("navigation-item", com.solevo.dist.theme.styles.NavigationItemStyle)
        ctx.theme.registerStyle("navigation-item-selected",
                com.solevo.dist.theme.styles.NavigationItemSelectedStyle)
        com.solevo.dist.initStyles(ctx)
        com.stevdza.san.kotlinbs.initBuildScriptLayers(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo("/" +
            BasePath.remove(window.location.href.removePrefix(window.origin).trimStart('/')),
            UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        com.solevo.dist.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
